import { render, staticRenderFns } from "./AthleteComparativeData.vue?vue&type=template&id=440fd324&scoped=true&"
import script from "./AthleteComparativeData.vue?vue&type=script&lang=ts&"
export * from "./AthleteComparativeData.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteComparativeData.vue?vue&type=style&index=0&id=440fd324&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440fd324",
  null
  
)

export default component.exports